module.exports = "https://cwa.roocdn.com/_next/static/safari-pinned-tab.1cdbce2c.svg";